import { useEffect } from 'react'

import { logger } from '../../../utilities/instrumentation/logger'
import { useEffectEvent } from '../../../utilities/use-effect-event'
import type { CandidateModel } from '../../shared/candidate'

type CandidateTabOpenedTrackerProps = {
	eventName: 'Candidate: Tab Opened' | 'Candidate Side View: Tab Opened'
	tab: string
	candidate: CandidateModel
}

export function CandidateTabOpenedTracker({ eventName, tab, candidate }: CandidateTabOpenedTrackerProps) {
	const trackTabOpened = useEffectEvent(() => {
		logger.track(eventName, {
			data: {
				tab,
				candidate_id: candidate.id,
				candidate_score: candidate.score ? Math.round(candidate.score.percentage) : null,
				is_disqualified: !!candidate.disqualificationReason,
				profile_work_history_count: candidate.profileCounts?.workHistory ?? 0,
				profile_education_count: candidate.profileCounts?.education ?? 0,
				profile_licenses_count: candidate.profileCounts?.licenses ?? 0,
				unread_email_count: candidate.unreadEmailCount ?? 0,
			},
		})
	})

	useEffect(() => {
		trackTabOpened()
	}, [eventName, tab, candidate.id])

	return null
}
